import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useTextMonths = () => {
  const { t } = useTranslation(i18nNS.common);

  const months = [
    {
      label: t('common:Months.January'),
      value: '1',
    },
    {
      label: t('common:Months.February'),
      value: '2',
    },
    {
      label: t('common:Months.March'),
      value: '3',
    },
    {
      label: t('common:Months.April'),
      value: '4',
    },
    {
      label: t('common:Months.May'),
      value: '5',
    },
    {
      label: t('common:Months.June'),
      value: '6',
    },
    {
      label: t('common:Months.July'),
      value: '7',
    },
    {
      label: t('common:Months.August'),
      value: '8',
    },
    {
      label: t('common:Months.September'),
      value: '9',
    },
    {
      label: t('common:Months.October'),
      value: '10',
    },
    {
      label: t('common:Months.November'),
      value: '11',
    },
    {
      label: t('common:Months.December'),
      value: '12',
    },
  ];

  return [months];
};

export default useTextMonths;
